import { SearchFoodResultType } from "model/food/types"
import {
  isEdamaFood,
  isMyFood,
  isOpenFoodFactFood,
} from "model/food/utils/typeGuards/foodTypeGuards"
import EdamaFoodDetailsWithSchedule from "components/foodDetails/EdamaFoodDetailsWithSchedule"
import MyFoodDetailsWithSchedule from "components/foodDetails/MyFoodDetailsWithSchedule"
import OpenFoodFactFoodDetailsWithSchedule from "components/foodDetails/OpenFoodFactFoodDetailsWithSchedule"

interface FoodDetailsSectionProps {
  food: SearchFoodResultType
  onBack: () => void
}

const FoodDetailsSection = ({ food, onBack }: FoodDetailsSectionProps) => {
  if (isEdamaFood(food)) {
    return <EdamaFoodDetailsWithSchedule food={food} onBack={onBack} />
  }

  if (isOpenFoodFactFood(food)) {
    return <OpenFoodFactFoodDetailsWithSchedule food={food} onBack={onBack} />
  }

  if (isMyFood(food)) {
    return <MyFoodDetailsWithSchedule food={food} onBack={onBack} />
  }

  return null
}

export default FoodDetailsSection
